/**
 * Emails allowed to access the admin site (website).
 * Only users in this list can access admin pages after Google sign-in.
 */
export const ADMIN_WHITELIST: readonly string[] = [
  'shaul.almog@gmail.com',
  'shimibis@gmail.com',
  'david.cohen@example.com',
];

/**
 * Only this email may change a subscription's expiresAt date — a stricter check than
 * ADMIN_WHITELIST since this action grants/revokes paid access. Must match
 * SUPER_ADMIN_EMAIL in serverless/functions/src/index.ts (enforced server-side there;
 * this copy only controls whether the edit form renders).
 */
export const SUPER_ADMIN_EMAIL = 'shaul.almog@gmail.com';

/**
 * Normalize email for comparison (lowercase, trim).
 */
function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/**
 * Returns true if the given email is allowed to access the admin site.
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = normalizeEmail(email);
  return ADMIN_WHITELIST.some((allowed) => normalizeEmail(allowed) === normalized);
}

/**
 * Returns true if the given email is allowed to change subscription expiry dates.
 */
export function isSuperAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return normalizeEmail(email) === normalizeEmail(SUPER_ADMIN_EMAIL);
}
